<template>
  <div class="wf-violator-bar" role="alert" v-if="isOpen">
    <div class="wf-violator-bar-indicator">
      <div class="badge badge-white badge-pointed">
        {{ badge }}
      </div>
    </div>
    <div class="wf-violator-bar-body">
      <div class="wf-violator-bar-content d-inline">
        <slot name="content">
        </slot>
      </div>
      <a
        class="wf-violator-bar-cta-button btn-accent-gray border-white btn"
        :href="buttonUrl"
        v-if="buttonUrl"
      >
        {{ buttonText }}
        <span class="png-icon png-icon-icons-glyph--ko-chevron-right ml-3"></span>
      </a>
    </div>

    <button
      type="button"
      class="wf-violator-bar-close-button btn"
      data-dismiss="alert"
      aria-label="Close alert"
      @click="dismiss"
    >
      <span class="png-icon png-icon-icons-symbols--ko-txtclose"></span>
    </button>
  </div>
</template>

<script>

const dismissedViolatorBarIdsSessionKey = "patcraft.dismissedViolatorBarIds";

export default {
  props: {
    violatorBarId: {
      type: String,
      required: true
    },
    badge: {
      type: String,
      required: true
    },
    buttonUrl: {
      type: String,
      default: null
    },
    buttonText: {
      type: String,
      default: 'Learn more'
    }
  },
  data() {
    return {
      dismissedViolatorBarIds: []
    }
  },
  computed: {
    isOpen: function() {
      return this.dismissedViolatorBarIds.indexOf(this.violatorBarId) === -1;
    }
  },
  methods: {
    dismiss: function() {
      this.dismissedViolatorBarIds.push(this.violatorBarId);
      window.sessionStorage.setItem(dismissedViolatorBarIdsSessionKey, JSON.stringify(this.dismissedViolatorBarIds));
    }
  },
  created: function() {
    let dismissedInStorage = JSON.parse(window.sessionStorage.getItem(dismissedViolatorBarIdsSessionKey));
    if (dismissedInStorage === null) {
      dismissedInStorage = [];
    }
    this.dismissedViolatorBarIds = dismissedInStorage;
  }
}
</script>